import ButtonTriangleSpinner from "../../ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import CommonModal from "../CommonModal.jsx";
import { toPlainDecimalString } from "../../../../helpers/commonHelper";
import './CandelOrderConfirmationModal.scss';
export const CancelOrderConfirmationModal = ({
  show,
  handleClose,
  data,
  isSubmitted
}) => {
  const orderId = data?.orderNumber ?? data?.id ?? data?.orderId ?? '—';
  const sideLabel = data?.side === 0 ? 'BUY' : 'SELL';
  const sideClass = data?.side === 0 ? 'green_text' : 'red_text';
  const orderTypeLabel = data?.type === 0 ? 'LIMIT' : 'MARKET';
  const pairLabel = String(data?.pair_key ?? data?.pairName ?? '').toUpperCase();
  const quantityLabel = toPlainDecimalString(data?.quantity);
  const priceLabel = toPlainDecimalString(data?.price);
  return <CommonModal show={show} handleClose={() => handleClose(null, false)} backdropClassName="transaction_modal_bckdrop" backdrop="static" disableClose={isSubmitted} className="CancelOrderConfirmationModal"
  // eyebrow="Trading"
  heading="Cancel Order Confirmation">
      <div className="cancelOrderModal">
        <p className="cancelOrderModal__lead">
          Do you want to cancel order <strong>#{orderId}</strong>?
        </p>

        <div className="cancelOrderModal__orderCard">
          <div className="cancelOrderModal__orderMain">
            <div className="cancelOrderModal__orderLine">
              <span className={sideClass}>{sideLabel}</span>
              <span>
                {quantityLabel} {pairLabel} @{priceLabel} {orderTypeLabel}
              </span>
            </div>
            {data?.advanceOrderType ? <div className="cancelOrderModal__orderMeta">{data.advanceOrderType}</div> : null}
          </div>
        </div>

        <div className="cancelOrderModal__actions">
          <button type="button" className="cancelOrderModal__btn cancelOrderModal__btn--secondary" disabled={isSubmitted} onClick={() => handleClose(null, false)}>
            Cancel
          </button>
          <button type="button" className="cancelOrderModal__btn cancelOrderModal__btn--primary" disabled={isSubmitted} onClick={() => handleClose(data, true)}>
            {isSubmitted ? <span className="cancelOrderModal__spinner" aria-hidden="true">
                <ButtonTriangleSpinner size={18} />
              </span> : 'Confirm'}
          </button>
        </div>
      </div>
    </CommonModal>;
};